/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log( 'Hello World! (from africamps-block-content-readmore block)' );
/* eslint-enable no-console */


// Read more/less stuff
jQuery(document).ready(function($) {

    function readmore(e){
  
      e.preventDefault();
      var button = $(this);
      var column = button.parent();
  
      $('.excerpt', column).css('height', 'auto');
      button.remove();
  
      $('<a>', {
          href: "#",
          class: 'btn-readless',
      }).html('Read less <i class="fas fa-chevron-up"></i>').click(readless).appendTo(column)
      
    }
  
    function readless(e){
  
      e.preventDefault();

      var button = $(this);
      var column = button.parent();
      var lines = column.data('lines');
  
      $('.excerpt', column).css('height', 'calc(20px + (1.7rem * ' + lines + '))')
      button.remove();
  
      $('<a>', {
          href: "#",
          class: 'btn-readmore',
      }).html('Read more <i class="fas fa-chevron-down"></i>').click(readmore).appendTo(column)
    }
  
    $('.wp-block-africamps-block-content-readmore').each(function(){
        
      var column = $(this);
      var lines = column.data('lines');

      $('<div>', {
          class: 'excerpt',
      }).css('height', 'calc(20px + (1.7rem * ' + lines + '))').appendTo(column)
  
      $('p', column).each(function(){
        $(this).detach().appendTo($('.excerpt', column))
      })
  
      $('<a>', {
          href: "#",
          class: 'btn-readmore',
      }).html('Read more <i class="fas fa-chevron-down"></i>').click(readmore).appendTo(column)
  
    });
});